export default {
  global: {
    send: 'Enviar',
    save: 'Guardar ',
    confirm: 'Confirmar',
    cancel: 'Anular',
    brand: 'HeiGIT - Heidelberg University',
    close: 'Cerrar',
    closeAndDoNotShowAgain: 'Fechar e não exibir novamente',
    select: 'Seleccionar',
    yes: 'Sí',
    no: 'No',
    and: 'y',
    noAndDonAskAgain: 'No (no vuelvas a preguntar)',
    ok: 'OK',
    polygon: 'polígono',
    developedByIntro: 'Servicios desarrollados por',
    developedBy: 'Instituto de Tecnología de Geoinformación de Heidelberg',
    duration: 'Duración',
    distance: 'Distancia',
    elevation: 'Elevación',
    profile: 'Perfil',
    options: 'Opciones',
    parameters: 'Parámetros',
    custom: 'Personalizado',
    customOverlayer: 'Capa adicional personalizada',
    rawRouting: 'Enrutamiento sin procesar',    
    months: {
      january: 'Enero',
      february: 'Febrero',
      march: 'Marzo',
      april: 'Abril',
      may: 'Mayo',
      june: 'Junio',
      july: 'Julio',
      august: 'Agosto',
      september: 'Septiembre',
      october: 'Octubre',
      november: 'Noviembre',
      december: 'Diciembre'
    },
    monthsShort: {
      january: 'Ene',
      february: 'Feb',
      march: 'Mar',
      april: 'Abr',
      may: 'May',
      june: 'Jun',
      july: 'Jul',
      august: 'Ago',
      september: 'Sep',
      october: 'Oct',
      november: 'Nov',
      december: 'Dic'
    },
    units: {
      km: 'km',
      mi: 'M',
      m: 'm',
      meters: 'metros',
      s: 's',
      seconds: 'segundos',
      minutes: 'minutos',
      hours: 'h',
      days: 'd',
      min: 'min',
      lat: 'lat',
      lng: 'long',
      tones: 'toneladas',
      t: 't',
      kmh: 'km/h'
    },
    layers: {
      macrocounty: 'Macro condado',
      country: 'País',
      region: 'Región',
      county: 'Condado',
      macroregion: 'Macro región',
      neighbourhood: 'Barrio',
      locality: 'Pueblo',
      borough: 'Municipio',
      localadmin: 'Administración local',
      address: 'Dirección',
      street: 'Calle',
      venue: 'Lugar',
      rawCoordinate: 'Coordenadas simples lng,lat',
      notAvailable: 'No disponible',
      postalcode: 'Código postal',
      'undefined': 'No definido',
      ocean: 'Oceano'
    },
    population: 'Población',
    green: 'Verde',
    noise: 'Ruido',
    steepness: 'Inclinación',
    surface: 'Superfície',
    roadaccessrestrictions: 'Restricciones de acceso por carretera',
    waytypes: 'tipos de camino',
    suitability: 'Adecuación',
    waycategory: 'Categoria de camino',
    tollways: 'Peajes',
    traildifficulty: 'Dificultad del camino',
    osmid: 'OSM ID',
    countryinfo: 'Información sobre el país'
  }
}
